function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { organization_team_list_path, RouteNames } from '@repo/routes';
import { getItemPath } from '@repo/utils';
import { Link } from '../Link';
import { CardFooter } from '../card-footer';
import { AvatarList } from '../card-item-elements';
import { ItemCounter } from '../item-counter';
import { VisibilityTag } from '../visibility-tag';
function ApplicationItem(param) {
    let { application, authUserName, gitTags } = param;
    const { organization, project } = application;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full bg-bg-primary-default px-4 py-3 border-b border-border",
        "data-e2e": "application-item",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-row items-center justify-between",
                "data-e2e": "application-item-stack",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-4/5 flex items-center gap-2",
                        "data-e2e": "application-item-left-side-info",
                        children: [
                            /*#__PURE__*/ _jsx(VisibilityTag, {
                                label: application.isPrivate ? 'private' : 'public'
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex items-center gap-2",
                                children: /*#__PURE__*/ _jsxs("p", {
                                    className: "m-0 text-tx-secondary-default text-base font-medium leading-[150%] cursor-default w-max",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            className: "text-white no-underline text-base",
                                            to: RouteNames.ORGANIZATION,
                                            params: {
                                                organization: organization.name
                                            },
                                            children: organization.name
                                        }),
                                        "\xa0/\xa0",
                                        /*#__PURE__*/ _jsx(Link, {
                                            className: "text-white no-underline text-base",
                                            to: RouteNames.PROJECT_OVERVIEW,
                                            params: {
                                                organization: organization.name,
                                                project: project.name
                                            },
                                            children: project.displayName
                                        }),
                                        "\xa0/\xa0",
                                        /*#__PURE__*/ _jsx(Link, {
                                            className: "no-underline text-base",
                                            to: RouteNames.APPLICATION_OVERVIEW,
                                            params: {
                                                organization: organization.name,
                                                project: project.name,
                                                application: application.name
                                            },
                                            search: {
                                                gitTags: gitTags === null || gitTags === void 0 ? void 0 : gitTags.join(',')
                                            },
                                            children: application.name
                                        })
                                    ]
                                })
                            }),
                            ' ',
                            /*#__PURE__*/ _jsx(Link, {
                                to: RouteNames.APPLICATION_VERSIONS,
                                className: "no-underline",
                                params: {
                                    organization: organization.name,
                                    project: project.name,
                                    application: application.name
                                },
                                children: /*#__PURE__*/ _jsx(VisibilityTag, {
                                    label: "Versions"
                                })
                            }),
                            /*#__PURE__*/ _jsx(ItemCounter, {
                                counters: application.counters,
                                hostPlatform: application.hostPlatform,
                                params: {
                                    organization: organization.name,
                                    project: project.name,
                                    application: application.name
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-6",
                        "data-e2e": "application-item-right-data",
                        children: /*#__PURE__*/ _jsx(AvatarList, {
                            list: getAvatarList({
                                contributors: application.contributors,
                                organization: organization.name,
                                authUserName
                            }),
                            limitedRightDataItemHref: organization_team_list_path({
                                organization
                            }),
                            showElse: true,
                            showAmount: 3
                        })
                    })
                ]
            }),
            !!application.description && /*#__PURE__*/ _jsx("div", {
                className: "max-w-160",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "block text-ellipsis overflow-hidden text-tx-secondary-alt whitespace-nowrap text-sm",
                    children: application.description
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(CardFooter, {
                    deletedAt: application.deletedAt,
                    updatedAt: application.updatedAt
                })
            })
        ]
    });
}
const getAvatarList = (param)=>{
    let { contributors, organization, authUserName } = param;
    if (!contributors.length) {
        return [];
    }
    return contributors.map((item)=>{
        return _object_spread_props(_object_spread({}, item), {
            href: getItemPath(_object_spread({
                authUserName,
                organization
            }, item)),
            imageSrc: '/'
        });
    });
};
export { ApplicationItem };
